<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.fp_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
        <div class="weui-form-preview__item" slot="fp_billdate" key="申请日期">
            <label class="weui-form-preview__label">{{
              customLabel.fp_billdate || "申请日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.fp_billdate,'yyyy-MM-dd')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_pleaseman" key="报销人">
            <label class="weui-form-preview__label">{{
              customLabel.fp_pleaseman || "报销人"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.fp_department }} {{ form.main.fp_pleaseman }}
              <router-link
                class="iconfont icon-history"
                :to="{
                  path: '/oa/fee_list',
                  query: { hq_keyword: form.main.fp_pleaseman },
                }"
              ></router-link>
              <call-mobile :em-id="form.main.fp_pleasemanid"></call-mobile>
            </span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.fp_department"
            slot="fp_department"
            key="报销部门"
          >
            <label class="weui-form-preview__label">{{
              customLabel.fp_department || "报销部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fp_department
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_type" key="申请类型">
            <label class="weui-form-preview__label">{{
              customLabel.fp_type || "申请类型"
            }}</label>
            <span class="weui-form-preview__value">{{
               form.main.fp_type
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.fp_receiver"
            slot="fp_receiver"
            key="收款名称"
          >
            <label class="weui-form-preview__label">{{
              customLabel.fp_receiver || "收款名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fp_receiver
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.fp_bankaccount"
            slot="fp_bankaccount"
            key="fp_bankaccount"
          >
            <label class="weui-form-preview__label">{{
              customLabel.fp_bankaccount || "银行账号"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.fp_bank }} {{ form.main.fp_bankaccount }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="fp_currency" key="币种">
            <label class="weui-form-preview__label">{{
              customLabel.fp_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fp_currency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_pleaseamount" key="报销金额(元)">
            <label class="weui-form-preview__label">{{
              customLabel.fp_pleaseamount || "报销金额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.fp_pleaseamount,'#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_paystatus" key="支付状态">
            <label class="weui-form-preview__label">{{
              customLabel.fp_paystatus || "支付状态"
            }}</label>
            <span class="weui-form-preview__value">{{
               form.main.fp_paystatus
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_endstatus" key="结案状态">
            <label class="weui-form-preview__label">{{
              customLabel.fp_endstatus || "结案状态"
            }}</label>
            <span class="weui-form-preview__value">{{
               form.main.fp_endstatus
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_payamount" key="已支付金额">
            <label class="weui-form-preview__label">{{
              customLabel.fp_payamount || "已支付金额"
            }}</label>
            <span class="weui-form-preview__value">{{
               form.main.fp_payamount
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_sourcetype" key="来源类型">
            <label class="weui-form-preview__label">{{
              customLabel.fp_sourcetype || "来源类型"
            }}</label>
            <span class="weui-form-preview__value">{{
               form.main.fp_sourcetype
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_sourcecode" v-if="form.main.fp_sourcecode">
            <label class="weui-form-preview__label">{{
              customLabel.fp_sourcecode || "来源单号"
            }}</label>
            <span class="weui-form-preview__value text-link" @click="showSource">{{
              form.main.fp_sourcecode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fp_content" key="费用内容">
            <label class="weui-form-preview__label">{{
              customLabel.fp_content || "费用内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fp_content
            }}</span>
          </div>
          
          
         
          <custom-field :readOnly="true" :label="customLabel.fp_text1 || '自定义字段1'"
          v-model="form.main.fp_text1" slot="fp_text1" hidden="true" key="fp_text1" />
          <custom-field :readOnly="true" :label="customLabel.fp_text2 || '自定义字段2'"
          v-model="form.main.fp_text2" slot="fp_text2" hidden="true" key="fp_text2" />
          <custom-field :readOnly="true" :label="customLabel.fp_text3 || '自定义字段3'"
          v-model="form.main.fp_text3" slot="fp_text3" hidden="true" key="fp_text3" />
          <custom-field :readOnly="true" :label="customLabel.fp_text4 || '自定义字段4'"
          v-model="form.main.fp_text4" slot="fp_text4" hidden="true" key="fp_text4" />
          <custom-field :readOnly="true" :label="customLabel.fp_text5 || '自定义字段5'"
          v-model="form.main.fp_text5" slot="fp_text5" hidden="true" key="fp_text5" />
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'费用明细（'+form.items1.length+'条）'" v-if="form.items1 && form.items1.length">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.fpd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="fpd_itemname">
              <label class="weui-form-preview__label">{{
                customLabel.fpd_itemname || "费用类型"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fpd_itemname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fpd_purpose">
              <label class="weui-form-preview__label">{{
                customLabel.fpd_purpose || "费用用途"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fpd_purpose
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fpd_actualamount">
              <label class="weui-form-preview__label">{{
                customLabel.fpd_actualamount || "实际金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.fpd_actualamount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fpd_catename">
              <label class="weui-form-preview__label">{{
                customLabel.fpd_catename || "费用科目"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fpd_catename
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.fpd_remark"
              slot="fpd_remark"
            >
              <label class="weui-form-preview__label">{{
                customLabel.fpd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fpd_remark
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.fpd_text1 || '自定义字段1'"
            v-model="item.fpd_text1" slot="fpd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.fpd_text2 || '自定义字段2'"
            v-model="item.fpd_text2" slot="fpd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.fpd_text3 || '自定义字段3'"
            v-model="item.fpd_text3" slot="fpd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.fpd_text4 || '自定义字段4'"
            v-model="item.fpd_text4" slot="fpd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.fpd_text5 || '自定义字段5'"
            v-model="item.fpd_text5" slot="fpd_text5" hidden="true" />
          </custom-layout>
        </div>
      </collapse>
      <collapse class="form-preview weui-form-preview" :title="'借款明细（'+form.items2.length+'条）'" v-if="form.items2 && form.items2.length">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item,index) in form.items2"
          :key="index"
        >
          <div class="form-detail-preview_num">{{ index+1 }}</div>
          <custom-layout :view-config="customViewConfig" position="detail2">
            <div class="weui-form-preview__item" slot="fplo_locode">
              <label class="weui-form-preview__label">{{
                customLabel.fplo_locode || "借款申请单"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fplo_locode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="lo_date">
              <label class="weui-form-preview__label">{{
                customLabel.lo_date || "借款日期"
              }}</label>
              <span class="weui-form-preview__value">{{ item.lo_date }}</span>
            </div>
            <div class="weui-form-preview__item" slot="lo_pleaseman">
              <label class="weui-form-preview__label">{{
                customLabel.lo_pleaseman || "借款人"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.lo_pleaseman
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="lo_borrowamount">
              <label class="weui-form-preview__label">{{
                customLabel.lo_borrowamount || "借款金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.lo_borrowamount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="sureturnamount">
              <label class="weui-form-preview__label">{{
                customLabel.sureturnamount || "剩余还款金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.sureturnamount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fplo_amount">
              <label class="weui-form-preview__label">{{
                customLabel.fplo_amount || "本次抵消金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.fplo_amount,'#,##0.00')
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.fplo_remark"
              slot="fplo_remark"
            >
              <label class="weui-form-preview__label">{{
                customLabel.fplo_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fplo_remark
              }}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>
      <collapse class="form-preview weui-form-preview" :title="'客商明细（'+form.items3.length+'条）'" v-if="form.items3 && form.items3.length">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item,index) in form.items3"
          :key="index"
        >
          <div class="form-detail-preview_num">{{ index+1 }}</div>
          <custom-layout :view-config="customViewConfig" position="detail3">
            <div class="weui-form-preview__item" slot="fd_vendname" v-if="item.fd_vendname">
              <label class="weui-form-preview__label">{{
                customLabel.fd_vendname || "供应商"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fd_vendname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fd_custname" v-if="item.fd_custname">
              <label class="weui-form-preview__label">{{
                customLabel.fd_custname || "客户"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fd_custname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fd_amount">
              <label class="weui-form-preview__label">{{
                customLabel.fd_amount || "金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.fd_amount,'#,##0.00')
              }}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>

      <file-list v-model="form.main.fp_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/fee_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";
import Collapse from "@/components/Collapse.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
    CustomField,
    Collapse
  },
  data() {
    return {
      baseUrl: "/api/oa/feeplease",
      codeField: "fp_code",
      statusField: "fp_statuscode",
      caller: "FeePlease",
      xtype: "oa-feeplease-formpanel",
    };
  },
  methods: {
    showSource() {
      let {fp_sourceid, fp_sourcetype} = this.form.main;
      if (fp_sourcetype == '费用申请') {
        this.$router.push('/oa/fee_apply/' + fp_sourceid);
      } else if (fp_sourcetype == '用品申请') {
        this.$router.push('/oa/supplies_apply/' + fp_sourceid);
      }else if(fp_sourcetype == '项目管理'){
        this.$router.push('/plm/proj/' + fp_sourceid);
      }
    }
  }
};
</script>